import client from '../../providers/fetchClient'

export const createLead = data => client.post('/v3/leads/site', data)

export const createLeadsPartner = data => client.post('/v3/leads/partner', data)
